import { render, staticRenderFns } from "./ChooseGoods.vue?vue&type=template&id=043160ae&scoped=true&"
import script from "./ChooseGoods.vue?vue&type=script&lang=js&"
export * from "./ChooseGoods.vue?vue&type=script&lang=js&"
import style0 from "./ChooseGoods.vue?vue&type=style&index=0&id=043160ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043160ae",
  null
  
)

export default component.exports